import { createFormDataRequest } from "@/helpers/FormHelpers";
import TrainingBrochure, {
  TrainingBrochureFormSend,
  TrainingBrochureUpdateForm,
} from "@/interfaces/TrainingBrochure";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import api from "../api";

export const trainingBrochuresApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTrainingBrochures: build.query<
      IPaginateResponse<TrainingBrochure>,
      IFilters | undefined
    >({
      query: (data = {}) => {
        const params = createFormDataRequest(data);
        return {
          url: "/training-brochures",
          params,
        };
      },
      providesTags: (result, _error, _arg) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "TrainingBrochures" as const,
                id,
              })),
              { type: "TrainingBrochures", id: "LIST" },
            ]
          : [],
    }),
    storeTrainingBrochure: build.mutation<
      TrainingBrochure,
      TrainingBrochureFormSend
    >({
      query: (data) => {
        const body = createFormDataRequest(data);
        return {
          url: `/training-brochures`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [{ type: "TrainingBrochures", id: "LIST" }],
    }),
    getTrainingBrochure: build.query<TrainingBrochure, string>({
      query: (id) => `/training-brochures/${id}`,
      providesTags: (_result, _error, id) => [
        { type: "TrainingBrochures", id },
      ],
    }),
    updateTrainingBrochure: build.mutation<
      TrainingBrochure,
      [string, TrainingBrochureUpdateForm]
    >({
      query: ([id, body]) => ({
        url: `/training-brochures/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, [id]) => [
        { type: "TrainingBrochures", id },
      ],
    }),
    deleteTrainingBrochure: build.mutation<void, string>({
      query: (id) => ({
        url: `/training-brochures/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "TrainingBrochures", id: "LIST" }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetTrainingBrochuresQuery,
  useLazyGetTrainingBrochuresQuery,
  useStoreTrainingBrochureMutation,
  useDeleteTrainingBrochureMutation,
  useGetTrainingBrochureQuery,
  useUpdateTrainingBrochureMutation,
} = trainingBrochuresApi;
